const scrollTopMap = Object.create(null)

/**
 * Tab 根页滚动位置记忆（页面滚动在 window 上，keep-alive 不会自动保留）
 */
export default function scrollKeep(pageKey) {
    return {
        activated() {
            this.$nextTick(() => {
                const top = scrollTopMap[pageKey]
                if (top != null && top > 0) {
                    window.scrollTo(0, top)
                }
            })
        },
        deactivated() {
            scrollTopMap[pageKey] =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop ||
                0
        },
    }
}
